import React, { useEffect, useState } from 'react'
import Icon from '../../../app/icon/Icon'
import Markdown from 'react-markdown'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { useNavigate } from 'react-router-dom';

export default function AgentPromoteUnit({ form, id, modal, unitID, row, control, objectID, register, errors, clearErrors, setValue, trigger }: any): JSX.Element {


    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const currentUser = useAppSelector((state) => state.user.currentUser);
    const [selectedProduct, setSelectedProduct] = useState<string>("");
    const [selectedPeriod, setSelectedPeriod] = useState<string>("month");
    const [isTestMode, setIsTestMode] = useState(false);

    const productTypes = [
        {
            place: 1,
            price: 100,
            visual: `1st position — 100 BRICKS`
        },
        {
            place: 2,
            price: 50,
            visual: `2nd position — 50 BRICKS`
        },
        {
            place: 3,
            price: 20,
            visual: `2nd position — 20 BRICKS`
        }]



    // useEffect(() => {
    //     if (!selectedProduct) {
    //         setSelectedProduct(productTypes[0] || "Free");
    //     }
    // }, [productTypes]);

    const handleSubscriptionChange = async () => {
        try {
            let action;
            if (selectedProduct === "Free") {
                //  action = actions.cancel || cancelSubscription;
            } else {
                //   action = actions.create || createSubscription;
            }

            //   const response = await dispatch(action({ selectedProduct, selectedPeriod, isTestMode }));
            // if (response.isSuccessful) {
            //     // await dispatch(fetchUser());
            //     navigate(`/subscriptions/${selectedProduct}`);
            // }
        } catch (error) {
            console.error("Subscription change failed", error);
        }
    };

    return (
        <div>
            <div className={'px-2 mt-2   mb-8'}>
                <h1 className={'text-center my-2'}>Promote Your Unit for Increased Visibility and Viewings</h1>
                {/* <img
                    className="w-100 h-275px object-fit-contain mb-2 rounded-0 rounded-bottom "
                    src={scanningInstructions.QR_Code}
                    alt="cover_scan_qr"
                /> */}
                {/* <div className="mb-4 ">
                    <div className={'rounded rounded-sm bg-gray-300 p-4'}>
                        <label className={'form-label fw-bold fs-5 text-dark m-0 d-flex align-items-center text-uppercase '}>
                            <Icon name={'help'} className={'fs-2x text-info me-1'} />
                            Instruction
                        </label>
                        <div className='fw-semi fs-5  lh-1 mt-2'>
                            <Markdown>
                                1.   When you promote your unit, it becomes visible to a broader audience of agents for 24 hours. This increased exposure allows other agents to see your unit and potentially respond with interest. As a result, more agents will be aware of your listing, which can lead to additional viewings and a higher chance of finding the right match for your property.
                            </Markdown>
                            <Markdown>
                                2. By promoting, you maximize the visibility of your unit, making it easier to attract attention and generate more engagement. The more agents who know about your unit, the better the chances of finding a suitable tenant or buyer quickly.
                            </Markdown>
                            <Markdown>
                                3. Promoting is an effective way to create momentum and encourage more viewings, ultimately leading to faster and more successful transactions.
                            </Markdown>

                            <Markdown>
                                Promoted units are pinned to the selected positions, regardless of other sorting or listing algorithms. This feature ensures maximum visibility for the unit, increasing its chances of attracting potential customers. 🚀
                            </Markdown>
                        </div>
                    </div>
                </div> */}
            </div>


            <div className="position-manager">
                <h2>Manage position</h2>
                <select value={selectedProduct} onChange={(e) => { setSelectedProduct(e.target.value); }}>
                    {productTypes.map((type) => (
                        <option key={type.price} value={type.place}>{type.visual}</option>
                    ))}
                </select>
                <button onClick={handleSubscriptionChange}>Confirm</button>
            </div>


        </div>
    )
}
